import classNames from "classnames";
import { useTranslation } from "react-i18next";

type UpdateThresholdStep2LabelProps = {
  isSelected?: boolean;
};

const UpdateThresholdStep2Label: React.FunctionComponent<
  UpdateThresholdStep2LabelProps
> = ({ isSelected }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full text-left flex items-center text-sm">
      <span
        className={classNames(
          "rounded-full h-5 w-5 font-bold text-center flex justify-center items-center m-2",
          {
            "bg-primary-2 text-white": isSelected,
            "bg-gray-500 text-white": !isSelected,
          }
        )}
      >
        2
      </span>
      <span>{t("meter.update_threshold")}</span>
    </div>
  );
};

export default UpdateThresholdStep2Label;
